import { useAccount } from './../../../lib/context/account-context'

function useCustomerId() {
  const { customer } = useAccount()
  return customer?.id || null
}

export default useCustomerId
